import React, { useEffect } from 'react';
import { Button, Select, InputNumber, Form, Checkbox } from 'antd';
import _get from 'lodash/get';


const WithdrawalFeeForm = ({ coinFormData = {}, updateFormData, handleClose, coins = [], form, handleScreenChange, isWithdrawalEdit = false }) => {

    const { getFieldDecorator, setFieldsValue } = form;
    const withdrawal_fees = _get(coinFormData, 'withdrawal_fees', {});

    useEffect(() => {
        Object.keys(withdrawal_fees).map(data => {
            return setFieldsValue({
                [`${data}_value`]: withdrawal_fees[data].value,
                [`${data}_symbol`]: withdrawal_fees[data].symbol,
            });
        })
    }, [setFieldsValue, withdrawal_fees]);

    const handleUpdate = (e) => {
        e.preventDefault();
        const { getFieldsValue, validateFields } = form;
        validateFields((err) => {
            if (!err) {
                let body = getFieldsValue();
                let formProps = {};
                if (body) {
                    Object.keys(body).forEach(data => {
                        const temp = data.split('_');
                        formProps = {
                            ...formProps,
                            [temp[0]]: {
                                ...formProps[temp[0]],
                                [temp[1]]: body[data]
                            }
                        }
                    })
                }
                updateFormData('withdrawal_fees', formProps);
                if (isWithdrawalEdit) {
                    handleClose();
                } else {
                    handleScreenChange('final');
                }
            }
        });
    };

    return (
        <div className="coin-limit-wrap">
            <div className="title">Withdrawal Fees</div>
            <Form
                name="withdrawalForm"
                onSubmit={handleUpdate}
            >
                {Object.keys(withdrawal_fees).map((data, key) => {
                    const isActive = withdrawal_fees[data].hasOwnProperty('active') ? withdrawal_fees[data].active : true
                    
                    return <div key={key}>
                        <div>
                            <div className="sub-title">{data.toUpperCase()}</div>
                        </div>
                        <div className="last">
                            <div className="sub-title">Value</div>
                            <Form.Item>
                                {getFieldDecorator(`${data}_value`, {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please enter the amount'
                                        }
                                    ]
                                })(<InputNumber />)}
                            </Form.Item>
                        </div>
                        <div className="last">
                            <div className="sub-title">Symbol</div>
                            <Form.Item>
                                {getFieldDecorator(`${data}_symbol`, {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please enter the amount'
                                        }
                                    ]
                                })(<Select
                                    size="small"
                                >
                                    {coins.map((option, index) => (
                                        <Select.Option key={index} value={option.symbol}>
                                            {option.symbol}
                                        </Select.Option>
                                    ))}
                                </Select>)}
                            </Form.Item>
                        </div>
                        <div className="last">
                            <Form.Item>
                                <span className="sub-title mr-1">Active: </span>
                                {getFieldDecorator(`${data}_active`, {
                                    initialValue: isActive,
                                })(
                                    <Checkbox defaultChecked={isActive} />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                })}
                {isWithdrawalEdit
                    ?
                    <div className='next-btn'>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            Next
                        </Button>
                    </div>
                    :
                    <div className="btn-wrapper">
                        <Button
                            type="primary"
                            onClick={() => handleScreenChange('step9')}
                        >
                            Back
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            Next
                        </Button>
                    </div>
                }
            </Form>
        </div>
    );
};

const WithdrawalFee = Form.create({
    name: 'WithdrawalFee'
})(WithdrawalFeeForm);

export default WithdrawalFee;
